import { useContext, useEffect, useState } from 'react'
import { Container, Row, Col } from 'components/grid'
import Icon from 'components/icon'
import SubNav from 'components/subnav'
import AeditLink from 'services/link'
import { GlobalContext } from 'components/global'
import { COLLECTIONS_ERROR } from 'services/constants'
import styles from './styles.scss'

const CollectionsSubnav = ({ sticky, top, ...rest }) => {
  const [open, setOpen] = useState(false)
  const { collections = [], loadCollections } = useContext(GlobalContext)

  useEffect(() => {
    if (
      collections !== COLLECTIONS_ERROR &&
      Array.isArray(collections) &&
      collections.length < 1 &&
      loadCollections !== undefined
    ) {
      loadCollections()
    }
  }, [loadCollections])

  const belowMobile = top || '.header-mobile'

  return (
    <>
      <SubNav className="collections-nav" sticky={sticky} top={belowMobile} {...rest}>
        <Container
          className={`nav-header ${open ? 'open' : ''}`}
          onClick={e => {
            e.preventDefault()
            setOpen(!open)
          }}>
          <Row>
            <Col>
              <div className="hidden-md-up d-flex caption dropdown">
                <div>AEDITION</div>
                <div className="d-flex control">
                  <span className="mr-1 ml-2">All</span>
                  <Icon name={open ? 'caret-up' : 'caret-down'} />
                </div>
              </div>
              {/* copied from old aedition */}
              <div className="hidden-md aedition-nav-wrapper">
                <h2 className="aedition-header">The AEDITION</h2>
                <ul className="collections-links">
                  <li>
                    <AeditLink pathname="/aedition">All</AeditLink>
                  </li>
                  {collections.map(({ title, slug }) => (
                    <li key={`collection-link-${slug}`}>
                      <AeditLink
                        pathname="/aedition/collection/[slug]"
                        as={`/aedition/collection/${slug}`}>
                        {title}
                      </AeditLink>
                    </li>
                  ))}
                </ul>
              </div>
              {/* end copied */}
            </Col>
          </Row>
        </Container>
        <Container className={`hidden-md-up caption nav-content ${open ? 'open' : ''}`}>
          {Array.isArray(collections) ? (
            collections.map(({ title, slug }) => (
              <AeditLink
                key={`collection-nav-link-${slug}`}
                className="nav-content-link"
                as={`/aedition/collection/${slug}`}
                pathname="/aedition/collection/[slug]">
                <Row>
                  <Col>
                    <div className="vertical-center dark-gray nav-content-item">{title}</div>
                  </Col>
                </Row>
              </AeditLink>
            ))
          ) : (
            <></>
          )}
        </Container>
      </SubNav>
      <style jsx global>
        {styles}
      </style>
    </>
  )
}

export default CollectionsSubnav
